import { Route, Routes } from "react-router-dom";
import RequireAuth from "./components/RequireAuth";
import WarRoomMusic from "./components/WarRoomMusic";
import InferenceDrawer from "./components/InferenceDrawer";
import CommandSurface from "./pages/CommandSurface";
import NotFound from "./pages/NotFound";
import UploadFiling from "./pages/UploadFiling";
import UploadEvidence from "./pages/UploadEvidence";
import UploadDocuments from "./pages/UploadDocuments";
import WarRoom from "./pages/WarRoom";
import DocketBoard from "./pages/DocketBoard";
import Raven from "./pages/commands/Raven";
import HellHounds from "./pages/commands/HellHounds";
import Horn from "./pages/commands/Horn";
import ShieldWall from "./pages/commands/ShieldWall";
import LightTheArrows from "./pages/commands/LightTheArrows";
import OathbreakerLedger from "./pages/commands/OathbreakerLedger";
import RelevanceLedger from "./pages/commands/RelevanceLedger";
import AuthorityLedger from "./pages/commands/AuthorityLedger";
import JustificationLedger from "./pages/commands/JustificationLedger";
import Berserkrs from "./pages/commands/Berserkrs";

/**
 * App routes. All routes are wrapped in <RequireAuth>.
 *   /                          → command surface (cases list)
 *   /upload                    → upload a filing (the Eater)
 *   /upload-evidence           → upload evidence email PDFs (the Eater)
 *   /case/:caseId              → War Room (the throne)
 *   /case/:caseId/board        → Docket Board (the chessboard surface)
 *   /case/:caseId/raven        → Raven (recon dossiers)
 *   /case/:caseId/hounds       → Hell Hounds (evidence + chat)
 *   /case/:caseId/horn         → The Horn (case timeline)
 *   /case/:caseId/shield-wall  → Shield Wall (defensive strategy)
 *   /case/:caseId/arrows       → Light the Arrows (claim refutation)
 *   /case/:caseId/oathbreaker  → Oathbreaker ledger (perjury / Rule 11)
 *   /case/:caseId/berserkrs    → Berserkrs (strike artifacts)
 *   *                          → NotFound
 */
function App() {
  return (
    <RequireAuth>
      <WarRoomMusic />
      <InferenceDrawer />
      <Routes>
        <Route path="/" element={<CommandSurface />} />
        <Route path="/upload" element={<UploadFiling />} />
        <Route path="/upload-evidence" element={<UploadEvidence />} />
        <Route path="/upload-documents" element={<UploadDocuments />} />
        <Route path="/case/:caseId" element={<WarRoom />} />
        <Route path="/case/:caseId/board" element={<DocketBoard />} />
        <Route path="/case/:caseId/raven" element={<Raven />} />
        <Route path="/case/:caseId/hounds" element={<HellHounds />} />
        <Route path="/case/:caseId/horn" element={<Horn />} />
        <Route path="/case/:caseId/shield-wall" element={<ShieldWall />} />
        <Route path="/case/:caseId/arrows" element={<LightTheArrows />} />
        <Route path="/case/:caseId/oathbreaker" element={<OathbreakerLedger />} />
        <Route path="/case/:caseId/relevance" element={<RelevanceLedger />} />
        <Route path="/case/:caseId/authority" element={<AuthorityLedger />} />
        <Route path="/case/:caseId/justification" element={<JustificationLedger />} />
        <Route path="/case/:caseId/berserkrs" element={<Berserkrs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </RequireAuth>
  );
}

export default App;
